import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import classnames from 'classnames';
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import { colors } from "../../../enums";
/**
 * return the border radius of the passed in element
 */

var getElementBorderRadius = function getElementBorderRadius(element) {
  return element ? window.getComputedStyle(element).getPropertyValue('border-radius') : null;
};

var Hoverable = createComponent({
  displayName: 'Hoverable',
  propTypes: {
    color: PropTypes.oneOf([colors.WHITE, colors.ACCENT, colors.WARNING]),
    opacity: PropTypes.number,
    display: PropTypes.oneOf(['inline-block', 'block']),
    isCircular: PropTypes.bool,
    isRounded: PropTypes.bool,
    transform: PropTypes.string,
    transition: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      property: PropTypes.string,
      duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      timingFunction: PropTypes.oneOf(['ease', 'linear', 'ease-in', 'ease-out', 'ease-in-out', 'step-start', 'step-end']),
      delay: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })])
  },
  defaultProps: {
    color: null,
    opacity: null,
    display: 'inline-block',
    isCircular: false,
    isRounded: false,
    transform: null,
    transition: 'all 500ms ease 0s'
  },
  state: {
    isDimmed: {
      value: false,
      updater: function updater(setIsDimmed) {
        return {
          dim: function dim() {
            return setIsDimmed(true);
          },
          undim: function undim() {
            return setIsDimmed(false);
          }
        };
      }
    }
  },
  refs: 'contentChildRef',
  render: function render(props) {
    var _classnames;

    var children = React.Children.toArray(props.children);

    var overlayChildren = _findInstanceProperty(children).call(children, function (child) {
      return Utils.isType(Hoverable.OnHover, child);
    });

    var contentChild = _findInstanceProperty(children).call(children, function (child) {
      return !Utils.isType(Hoverable.OnHover, child);
    }); // some elements have a border radius so the hover element needs to respect that


    var childBorderRadius = Utils.isStateless(contentChild) && props.refs.contentChildRef ? getElementBorderRadius(props.refs.contentChildRef.children[0]) : // stateless components are wrapped in a div so we need to make sure we grab the first child element
    getElementBorderRadius(props.refs.contentChildRef); // otherwise we can just grab the contentChildRef

    logger.warn('Hoverable: only expects a single child', _.omit(children, function (child) {
      return Utils.isType(Hoverable.OnHover, child);
    }).length > 1);
    logger.warn('Hoverable: "transition" definition missing "property"', _.isObject(props.transition) && !props.transition.property);
    logger.warn('Hoverable: "transition" definition missing "duration"', _.isObject(props.transition) && !props.transition.duration);
    logger.warn('Hoverable: "transition" "duration" or "delay" missing a unit. Will not work without one.', _.isString(props.transition) && !_.isNaN(_.parseInt(_.last(props.transition))));
    var transition = normalizeTransition(props.transition);
    var className = classnames({
      ck: true,
      hoverable: true,
      dimmed: props.isDimmed,
      circular: props.isCircular,
      rounded: props.isRounded
    });
    var hoverContainerClassName = classnames({
      hover: true,
      active: props.isDimmed
    });
    var transformStyle = props.isDimmed && !!props.transform ? {
      WebkitTransform: props.transform,
      MozTransform: props.transform,
      msTransform: props.transform,
      OTransform: props.transform,
      transform: props.transform
    } : {};
    var transitionStyle = {
      WebkitTransition: transition,
      MozTransition: transition,
      OTransition: transition,
      transition: transition
    };

    var hoverContainerStyle = _extends({}, transitionStyle, transformStyle, {
      borderRadius: childBorderRadius
    });

    var hoverContentStyle = _extends({
      opacity: props.isDimmed ? 1 : 0
    }, transitionStyle, transformStyle);

    var contentChildStyle = _extends({}, contentChild.props.style, transitionStyle, transformStyle);

    var hoverableOverlayClassName = classnames((_classnames = {
      'hoverable-overlay': true
    }, _classnames["background-color-" + props.color] = props.isDimmed && props.color, _classnames));

    var hoverableOverlayStyle = _extends({}, transitionStyle, transformStyle, {
      opacity: props.opacity
    });

    logger.warn('Hoverable: "isRounded" and "isCircular" are mutually exclusive, please choose one or the other.', !!props.isRounded && !!props.isCircular);
    return /*#__PURE__*/React.createElement("div", {
      onMouseEnter: props.dim,
      onMouseLeave: props.undim,
      className: className,
      style: {
        display: props.display
      }
    }, Utils.isStateless(contentChild) ? /*#__PURE__*/React.createElement("div", {
      ref: props.setContentChildRef,
      style: {
        display: props.display
      },
      className: "hoverable-child"
    }, /*#__PURE__*/React.cloneElement(contentChild, {
      style: contentChildStyle
    })) : /*#__PURE__*/React.cloneElement(contentChild, {
      ref: props.setContentChildRef,
      style: contentChildStyle
    }), /*#__PURE__*/React.createElement("div", {
      className: hoverContainerClassName,
      style: hoverContainerStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: hoverableOverlayClassName,
      style: hoverableOverlayStyle
    }), /*#__PURE__*/React.createElement("div", {
      className: "hoverable-content",
      style: hoverContentStyle
    }, /*#__PURE__*/React.createElement("div", null, overlayChildren))));
  }
});

function normalizeTransition(transition) {
  if (_.isString(transition) || !transition) {
    return transition;
  }
  /*
    duration can be string or number. Normalize to string
    if not one of the two, then assumed to be incorrect value which React will warn
  */


  var duration;

  if (_.isString(transition.duration)) {
    duration = transition.duration;
  } else if (_.isNumber(transition.duration)) {
    duration = transition.duration.toString();
  }
  /*
    delay can be string or number. Normalize to string
    if not one of the two, then assumed to be incorrect value which React will warn
  */


  var delay;

  if (_.isString(transition.delay)) {
    delay = transition.delay;
  } else if (_.isNumber(transition.delay)) {
    delay = transition.delay.toString();
  }

  duration = normalizeTimeUnit(duration);
  delay = normalizeTimeUnit(delay);
  return transition.property + " " + duration + " " + transition.timingFunction + " " + delay;
}

function normalizeTimeUnit(time) {
  var _time = time; // Ensure a unit is defined. Can be either s (seconds) or ms (milliseconds)

  if (_.last(_time) !== 's') {
    // Assume if value greater than 10, then intent is for the unit to be milliseconds, otherwise seconds
    _time = _parseFloat(_time) > 10 ? _time + "ms" : _time + "s";
  }

  return _time;
}

var OnHover = createComponent({
  displayName: 'Hoverable.OnHover',
  propTypes: {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    value: PropTypes.any,
    id: PropTypes.any
  },
  defaultProps: {
    onClick: undefined,
    value: undefined,
    id: undefined
  },
  handlers: {
    handleClick: function handleClick(p) {
      return function (e) {
        !!p.onClick && p.onClick(e, {
          id: p.id,
          value: p.value
        });
      };
    }
  },
  render: function render(p) {
    var className = classnames({
      ck: true,
      'on-hover': true,
      clickable: !!p.onClick
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      onClick: p.handleClick,
      style: p.style
    }, p.children);
  }
});
Hoverable.OnHover = whitelistStyles()(OnHover);
export default Hoverable;
//# sourceMappingURL=hoverable.js.map